(() => {
  if (customElements.get('zd-product-layout')) return;

  class ProductLayout extends HTMLElement {
    connectedCallback() {
      this.setupTitle();
    }

    setupTitle() {
      const root = this.closest('section');
      this.titleHeading = root?.querySelector('.zd-product-title');
      this.titleName = this.titleHeading?.querySelector('.zd-product-title__name');
      this.titleToggle = root?.querySelector('[data-zd-title-toggle]');
      if (!this.titleName || !this.titleToggle) return;

      // Only the visual presentation is clamped; the full heading stays in HTML.
      this.titleHeading.classList.add('zd-product-title--collapsible');
      this.onTitleToggle = () => {
        this.titleHeading.classList.toggle('zd-product-title--expanded');
        this.updateTitleToggle();
      };
      this.titleToggle.addEventListener('click', this.onTitleToggle);
      this.titleResizeObserver = new ResizeObserver(() => this.updateTitleToggle());
      this.titleResizeObserver.observe(this.titleName);
      this.updateTitleToggle();
    }

    updateTitleToggle() {
      const style = getComputedStyle(this.titleName);
      const lines = Number(getComputedStyle(this.titleHeading).getPropertyValue('--zd-title-lines')) || 2;
      const maxHeight = Math.ceil(parseFloat(style.lineHeight) * lines);
      const needsToggle = this.titleName.scrollHeight > maxHeight + 2;
      this.titleToggle.hidden = !needsToggle;
      if (!needsToggle) this.titleHeading.classList.remove('zd-product-title--expanded');
      const expanded = this.titleHeading.classList.contains('zd-product-title--expanded');
      this.titleToggle.setAttribute('aria-expanded', String(expanded));
      this.titleToggle.textContent = expanded ? this.titleToggle.dataset.showLess : this.titleToggle.dataset.showMore;
    }

    disconnectedCallback() {
      this.titleResizeObserver?.disconnect();
      if (this.onTitleToggle) this.titleToggle?.removeEventListener('click', this.onTitleToggle);
      this.titleHeading?.classList.remove('zd-product-title--collapsible', 'zd-product-title--expanded');
      if (this.titleToggle) this.titleToggle.hidden = true;
    }
  }
  customElements.define('zd-product-layout', ProductLayout);
})();
